"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardParty',
    props: {
        party: {
            required: true,
            type: String,
        },
        size: {
            required: false,
            default: 'card',
            type: String,
        },
    },
    computed: {
        classes() {
            const p = this.party.toLowerCase().replace(' ', '-');
            const suffix = this.size === 'req' ? '-req' : '';
            return `card-party--${p}${suffix}`;
        },
    },
});
